import { store } from '../store/index.js'

export default (to, from, next) => {
  if (store.getters.user) {
    next()
  } else {
    // if not signed in lets grab this url and take them to sign in
    const loginpath = window.location.pathname
    // also include any queryparams ?a=1
    const queryparams = window.location.search
    next({ name: 'SignIn', query: { from: loginpath, queryparams: queryparams } })
  }
}
